import React from 'react'
import { connect } from 'react-redux'
import Portal from 'components/Portal/Portal'
import { history } from '../../../store'
import {
  extendUserSession,
  clearLocalUser,
  setExpiration,
  detachEventCheck,
  attachEventCheck
} from '../../../Auth/AuthActions'

////////////////////////
///////////////////////////////////////////////////////////////
//////////

///////////////////////////
//////////////////////////////////////////////////////////////////////////
//////////

class AuthTimer extends React.Component {
  render() {
    const { modalShown, expires } = this.props
    return (
      <Portal isOpened={modalShown}>
        {modalShown ? (
          <div className="auth-timer animated fadeIn fast-animation">
            <Timer initialTime={expires} />
          </div>
        ) : (
          <div />
        )}
      </Portal>
    )
  }
}
export default connect(state => ({
  modalShown: state.auth.expires ? state.auth.expires <= 30 : false,
  expires: state.auth.expires
}))(AuthTimer)

class Timer extends React.Component {
  constructor(props) {
    super(props)
    this.state = { time: props.initialTime }
    this.mounted = true
  }
  componentDidMount = () => {
    this.interval = window.setInterval(this.decrement, 1000)
    attachEventCheck()
    // window.addEventListener('mousemove', this.extendSession)
  }
  componentWillUnmount = () => {
    this.mounted = false
    window.clearInterval(this.interval)
    // window.removeEventListener('mousemove', this.extendSession)
    detachEventCheck()
  }
  decrement = () => {
    if (this.state.time > 0 && this.mounted) {
      this.setState(state => ({
        time: state.time - 1
      }))
    } else if (!this.mounted) {
      window.clearInterval(this.interval)
    } else {
      window.clearInterval(this.interval)
      this.props.setExpiration(null)
      detachEventCheck()
      clearLocalUser(true)
      if (process.env.LOGIN_REDIRECTS_TO_EPASS) {
        history.push('/')
      } else if (process.env.HAS_MILOGIN) {
        history.push('/session-timeout')
      }
//////////////////////////////
////////////////////////////
////////////////

/////////////////////////////////
///////////////////////////////
////////////////
    }
  }
  extendSession = () => {
    this.mounted = false
    // window.removeEventListener('mousemove', this.extendSession)
    this.props.extendUserSession(false)
  }
  render() {
    return (
      <div className="timer">
        <h4>Your session will expire in:</h4>
        <span>{this.state.time}</span>
      </div>
    )
  }
}
Timer = connect(
  null,
  { extendUserSession, setExpiration }
)(Timer)
